import React, { PropsWithChildren, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LeftNavTab, LeftNav, Loader } from '@fdha/web-ui-library';
import { Box, useTheme } from '@mui/material';

import { useGetUserType } from '../../hooks';
import { MainContainer } from '..';

const getTabs = (isAdmin: boolean): LeftNavTab[] => [
  {
    id: 'tab-home',
    label: 'Home',
    'aria-controls': 'tabpanel-tab-home',
    activeIcon: 'home',
    inactiveIcon: 'home-outline',
    to: '/',
    component: Link,
    'data-testId': 'TAB_HOME',
  },
  ...(isAdmin
    ? [
        {
          id: 'tab-trials',
          label: 'Trials',
          'aria-controls': 'tabpanel-tab-trials',
          activeIcon: 'trending-up',
          inactiveIcon: 'trending-up-outline',
          to: '/trials',
          component: Link,
          'data-testId': 'TAB_TRIALS',
        },
      ]
    : []),
  ...(isAdmin
    ? [
        {
          id: 'tab-settings',
          label: 'Settings',
          'aria-controls': 'tabpanel-tab-settings',
          activeIcon: 'settings-2',
          inactiveIcon: 'settings-2-outline',
          to: '/settings',
          component: Link,
          'data-testId': 'TAB_SETTINGS',
        },
      ]
    : []),
];

const AppLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { isAdmin, isLoading: loadingIsAdmin } = useGetUserType();
  const { pathname } = useLocation();
  const theme = useTheme();

  const tabs = getTabs(!!isAdmin);

  const selectedTabId = useMemo(() => {
    const regex = /\/([^/]+)/;
    const [firstPath] = pathname.match(regex) || [];

    return tabs.find((tab) => firstPath === tab.to)?.id || 'tab-home';
  }, [tabs, pathname]);

  const isLoading = loadingIsAdmin;

  return (
    <Box height="100vh">
      {isLoading ? (
        <Loader />
      ) : (
        <Box bgcolor={theme.palette.primary.main} display="flex" height="100%">
          <LeftNav
            tabs={tabs}
            activeTabId={selectedTabId}
            logo="/images/Faeth_Logo_IconOnly.png"
            data-testId="APP_BAR"
          />
          <MainContainer activeTabId={selectedTabId}>{children}</MainContainer>
        </Box>
      )}
    </Box>
  );
};

export default AppLayout;
